var _path, _g, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.8313 58.9125C47.8891 67.0325 16.8309 67.0325 7.08888 58.9125C-2.85336 50.7925 -1.84211 16.0798 7.08888 6.94853C16.0199 -2.18271 48.9003 -2.18271 57.8313 6.94853C66.7623 16.0798 67.7736 50.7925 57.8313 58.9125Z",
    fill: "#F25C54"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M32.6604 44.7052C23.7294 51.814 13.7872 55.4585 4.44567 55.6687C-2.45282 43.8942 -1.03107 15.269 7.08893 6.94875C14.3979 -0.560493 37.3362 -1.98224 50.5224 2.6835C53.7664 16.08 47.0681 33.131 32.6604 44.7052Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4989 32.5504L48.6302 23.329C50.5726 21.3666 50.5626 18.1927 48.5901 16.2503C46.6277 14.3079 43.4538 14.318 41.5114 16.2904L32.4603 25.4417L23.4091 16.2904C21.4667 14.328 18.2928 14.3079 16.3304 16.2503C14.368 18.1927 14.348 21.3666 16.2904 23.329L25.4216 32.5504L16.2904 41.7718C14.348 43.7342 14.358 46.9081 16.3304 48.8505C17.3016 49.8116 18.5832 50.3022 19.8548 50.3022C21.1464 50.3022 22.4379 49.8016 23.4091 48.8204L32.4603 39.6692L41.5114 48.8204C42.4926 49.8116 43.7842 50.3022 45.0658 50.3022C46.3374 50.3022 47.6089 49.8217 48.5901 48.8505C50.5525 46.9081 50.5726 43.7342 48.6302 41.7718L39.4989 32.5504Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCheck);
export default __webpack_public_path__ + "static/media/Red Check.9f2c9f5c7d1eeea9092ebdb61a4a6f73.svg";
export { ForwardRef as ReactComponent };